import { c as _c } from "react/compiler-runtime";
import { Either } from '@sola/schema/dotcom/helpers.ts';
import { IconNames, IconNamesSafe } from '@sola/schema/lib/icons/icon-names.ts';
export type ArkIconProps = Omit<React.ComponentPropsWithoutRef<'svg'>, 'children'> & {
  /**
   * If icon needs accessibility, set aria-hidden to false
   * and include an accessible title or aria-labelledby.
   */
  alt?: string;
  size?: string;
} & Either<{
  iconName: IconNames;
}, {
  children: React.ReactElement;
}>;
export const ArkIcon: React.FC<ArkIconProps> = t0 => {
  const $ = _c(20);
  let alt;
  let children;
  let fill;
  let iconName;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      iconName,
      alt,
      size,
      fill,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = children;
    $[3] = fill;
    $[4] = iconName;
    $[5] = props;
    $[6] = size;
  } else {
    alt = $[1];
    children = $[2];
    fill = $[3];
    iconName = $[4];
    props = $[5];
    size = $[6];
  }
  const t1 = size || "1em";
  const t2 = size || "1em";
  const t3 = fill || "none";
  const t4 = !alt || !!props["aria-labelledby"] || undefined;
  let t5;
  if ($[7] !== alt) {
    t5 = alt && <title>{alt}</title>;
    $[7] = alt;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== iconName) {
    t6 = children || <use href={`/sprites/icons.svg#cicon-${IconNamesSafe.parse(iconName)}`} />;
    $[9] = children;
    $[10] = iconName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <svg width={t1} height={t2} role="img" fill={t3} aria-hidden={t4} {...props}>{t5}{t6}</svg>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};